import classNames from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { IColumn } from 'core-components/library/list/types'
import { BaseCrud } from 'core-components/types'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../configs/translations'
import { hasOutcome as getHasOutcome } from '../../../helpers/activityOutcome'
import { IMdfActivity } from '../../../model/types'
import { LinkedInitiativeCell } from '../components/linkedInitiativeCell'
import styles from '../MdfActivitiesTable.module.scss'

import { getSummaryColumns } from './getSummaryColumns'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS

interface IGetColumnsParams {
  initiativesSource: BaseCrud<any>
  initiativesById: Map<number, string>
  savingEntryIds: number[]
  isUsd: boolean
  isReadOnly: boolean
  onLink: (activity: IMdfActivity, keyInitiativeId: number | null) => void
  onCreateInitiative: (activity: IMdfActivity, value: string) => void
  onOpenDetails: (activity: IMdfActivity) => void
}

const SETTINGS_HIDDEN = false
const SORTING_DISABLED = true

export const getColumns = ({
  initiativesSource,
  initiativesById,
  savingEntryIds,
  isUsd,
  isReadOnly,
  onLink,
  onCreateInitiative,
  onOpenDetails,
}: IGetColumnsParams): IColumn<IMdfActivity>[] => [
  ...getSummaryColumns({ isUsd }),
  {
    field: 'keyInitiativeId',
    title: KEYS.table.linkedInitiative,
    disableSort: SORTING_DISABLED,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.table.linkedInitiative} />,
    renderFunction: (item) => {
      return (
        <LinkedInitiativeCell
          activity={item}
          initiativesSource={initiativesSource}
          initiativesById={initiativesById}
          linkedName={
            item.keyInitiativeId !== null ? initiativesById.get(item.keyInitiativeId) : undefined
          }
          isSaving={savingEntryIds.includes(item.entryId)}
          isDisabled={isReadOnly}
          onLink={onLink}
          onCreateInitiative={onCreateInitiative}
        />
      )
    },
  },
  {
    field: 'outcome',
    title: KEYS.table.outcome,
    disableSort: SORTING_DISABLED,
    hideSettings: SETTINGS_HIDDEN,
    titleRender: () => <Translation text={KEYS.table.outcome} />,
    renderFunction: (item) => {
      const hasOutcome = getHasOutcome(item)

      if (!hasOutcome && item.statusCategory === 'Planning') {
        return <>—</>
      }

      return (
        <Button
          className={styles.outcomeLink}
          variant="text"
          size="sm"
          onClick={(e) => {
            e.stopPropagation()
            onOpenDetails(item)
          }}
          icon={classNames(
            'kbase',
            hasOutcome
              ? `kbase-check ${styles.outcomeIconProvided}`
              : `kbase-warning-alt ${styles.outcomeIconMissing}`
          )}
          iconPosition="start"
        >
          <Translation
            text={hasOutcome ? KEYS.table.outcomeProvided : KEYS.table.provideOutcome}
            span
          />
        </Button>
      )
    },
  },
]
